/* unplugin-vue-components disabled */import script from "./Menu.vue?vue&type=script&setup=true&lang=tsx"
export * from "./Menu.vue?vue&type=script&setup=true&lang=tsx"

import "./Menu.vue?vue&type=style&index=0&id=19e2ec52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e2ec52"]])

export default __exports__